module.exports = __webpack_public_path__ + "static/media/people-blue.2a626363.svg";